import Profile from './Profile'
import ProfileLanding from './ProfileLanding'
export {
    ProfileLanding
}
export default Profile